//@ts-nocheck

import styled, { css } from 'styled-components'
import { Paragraph } from '../../atoms/Typography/Typography.styles'

export const CardExpertiseTag = styled.span`
  display: inline-block;
  padding: ${({ theme }) => theme.rem(3, 12)};
  border-radius: ${({ theme }) => theme.rem(4)};
  font-size: ${({ theme }) => theme.rem(14)};
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: ${({ theme }) => theme.rem(8)};
  transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
`

export const CardExpertiseImage = styled.div`
  width: 100%;
  position: relative;
  aspect-ratio: 4 / 4;

  ${({ maskType }) => maskType && css`
    mask-image: url('/masks/mask-${maskType}.svg');
    mask-repeat: no-repeat;
    mask-size: 100%;
  `}

  ${({ maskType }) => maskType === 'circle' && css`
    mask-size: 130%;
    mask-position: center 40px;
  `}

  ${({ maskType }) => maskType === 'ellipse' && css`
    mask-size: 180%;
    mask-position: -20px -40px;
  `}

  ${({ maskType }) => maskType === 'leaf' && css`
    mask-size: 200%;
    mask-position: center -40px;
  `}

  img {
    object-fit: cover;
    object-position: center;
    transform: scale(1.1);
  }
`

export const CardExpertiseIcon = styled.div`
  width: ${({ theme }) => theme.rem(60)};
  height: ${({ theme }) => theme.rem(60)};
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 5%;
  right: 5%;
  border-radius: 100%;
  opacity: 0;
  transform: translate(-24px, 24px) scale(0.8);
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
`

export const CardExpertise = styled.a`
  width: 100%;
  height: 100%;
  max-height: ${({ theme }) => theme.rem(440)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  border-radius: ${({ theme }) => theme.rem(12)};
  transition: background-color 0.3s ease-in-out, transform 0.6s cubic-bezier(0.5, 2.5, 0.7, 0.7);
  text-decoration: none;
  overflow: hidden;
  
  ${({ theme, colorScheme }) => css`
    background-color: ${theme.colorScheme[`${colorScheme}`].surface.inside};
    color: ${theme.colorScheme[`${colorScheme}`].surface.text.base.primary};

    ${CardExpertiseIcon} {
      color: ${theme.colorScheme[`${colorScheme}`].button.primary.iconDefault};
      background-color: ${theme.colorScheme[`${colorScheme}`].button.primary.bgDefault};
    }
  `}

  &:hover,
  &:focus-within {
    color: ${({ theme, colorScheme }) => theme.colorScheme[`${colorScheme}`].button.primary.textHover};
    transform: translateY(-5px);

    ${CardExpertiseIcon} {
      background-color: ${({ theme, colorScheme }) => theme.colorScheme[`${colorScheme}`].button.primary.bgIcon};
      opacity: 1;
      transform: translate(0, 0) scale(1);
    }
  }
`

export const CardExpertiseText = styled.div`
  width: 100%;
  padding: ${({ theme }) => theme.rem(24, 16)};

  ${Paragraph} {
    color: ${({ theme, colorScheme }) => theme.colorScheme[`${colorScheme}`].surface.text.base.primary}!important;
  }
`
